import { CreditActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { CreditFormData } from 'src/screens/General/screens/Credits/components/CreditForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetCreditsAction {
    type: typeof CreditActions.FETCH_CREDITS;
    payload: QueryParams;
}

export function getCredits(params: QueryParams): GetCreditsAction {
    return {
        type: CreditActions.FETCH_CREDITS,
        payload: params,
    };
}

export interface GetCreditAction {
    type: typeof CreditActions.FETCH_CREDIT;
    payload: {
        id: string | number;
    };
}

export function getCredit(id: string | number): GetCreditAction {
    return {
        type: CreditActions.FETCH_CREDIT,
        payload: { id },
    };
}

export interface DeleteCreditAction {
    type: typeof CreditActions.DELETE_CREDIT;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteCredit(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteCreditAction {
    return {
        type: CreditActions.DELETE_CREDIT,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistCreditAction {
    type: typeof CreditActions.PERSIST_CREDIT;
    payload: {
        data: CreditFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistCredit(data: CreditFormData, callbacks: SagaPromise<any>): PersistCreditAction {
    return {
        type: CreditActions.PERSIST_CREDIT,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistCredit = (data: CreditFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistCredit(data, { resolve, reject }));
    });
};

export type Actions = GetCreditsAction | GetCreditAction | DeleteCreditAction | PersistCreditAction;
